<wr-base-dialog status="info" header="Prüfpunkt auswählen" [submitResponse]="onSubmit" [disableSubmit]="disableSubmit()">
  <div class="flex-container">
    <div>
      <label for="selectedCheckpointGroupId">Prüfpunkt Gruppe</label>
      <nb-select id="selectedCheckpointGroupId"
                 fullWidth
                 [(ngModel)]="selectedCheckpointGroupId"
                 (selectedChange)="onGroupChange()">
        <nb-option [value]="''">Alle Gruppen</nb-option>
        <nb-option *ngFor="let checkpointGroup of checkpointGroups()"
                   [value]="checkpointGroup.id">
          {{checkpointGroup.number}}.{{checkpointGroup.name}}
        </nb-option>
      </nb-select>
    </div>
    @if (selectedCheckpointGroupId !== undefined) {
      <div>
        <label for="selectedCheckpointId">Prüfpunkt</label>
        <nb-select id="selectedCheckpointId"
                   fullWidth
                   [(selected)]="selectedCheckpointId">
          <nb-option *ngFor="let checkpoint of checkpoints()"
                     [value]="checkpoint.id">
            {{checkpoint.checkpointGroupNumber}}.{{checkpoint.number}} {{checkpoint.name}}
          </nb-option>
        </nb-select>
      </div>
    }
  </div>
</wr-base-dialog>
